var render = function(_h, _vm) {
  var _c = _vm._c
  return _c("div", { staticClass: "header" }, [
    _c("div", { staticClass: "userContent" }, [_vm._v(_vm._s(_vm.props.value))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }